module.exports = __webpack_public_path__ + "img/phase2-sample-04.a1114c18.jpg";